module.exports = __webpack_public_path__ + "static/media/icon_green.239c307a.png";